import "./Footer.css"

const Footer = () => {
    return (
        <footer className="footer">
            <a href="/"><img className="logoNaruto" src="/img/icon-naruto.svg" alt="logo"/></a>
        </footer>
    )
}

export {Footer}